import script from "./InterventionsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InterventionsModal.vue?vue&type=script&lang=ts&setup=true"

import "./InterventionsModal.vue?vue&type=style&index=0&id=d6953bfa&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6953bfa"]])

export default __exports__